export default __webpack_public_path__ + "static/media/banner.f7d18513.png";